var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.31958C0 2.11044 1.79086 0.31958 4 0.31958H20C22.2091 0.31958 24 2.11044 24 4.31958V22.3196C24 24.5287 22.2091 26.3196 20 26.3196H4C1.79086 26.3196 0 24.5287 0 22.3196V4.31958Z",
    fill: "#1C6947",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3196V22.3196M16 15.3196V22.3196M20 11.3196V22.3196M22 4.31958L13.354 12.9656C13.3076 13.0121 13.2524 13.0491 13.1916 13.0743C13.1309 13.0995 13.0658 13.1125 13 13.1125C12.9342 13.1125 12.8691 13.0995 12.8084 13.0743C12.7476 13.0491 12.6924 13.0121 12.646 12.9656L9.354 9.67358C9.26024 9.57984 9.13308 9.52719 9.0005 9.52719C8.86792 9.52719 8.74076 9.57984 8.647 9.67358L2 16.3196M4 19.3196V22.3196M8 15.3196V22.3196",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "res/media/chart.25488d8586263942b366c83dff63caf7.svg";
export { ForwardRef as ReactComponent };